export const getPathLink = () => {
  let pathLink = '';

  if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'nl') {
    pathLink = '/nl/';
  } else if (
    document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-BE'
  ) {
    pathLink = '/fr-be/';
  } else if (
    document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-CA'
  ) {
    pathLink = '/fr-ca/';
  } else {
    pathLink = '/';
  }
  return pathLink;
};
